if (!customElements.get('tmg-wishlist')) {
  customElements.define(
    'tmg-wishlist',
    class TmgWishlist extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-wishlist-grid]');
        this.empty = this.querySelector('[data-wishlist-empty]');
        this.loading = this.querySelector('[data-wishlist-loading]');
        this.count = this.querySelector('[data-wishlist-count]');
        this.cardSection = this.dataset.cardSection;
        this.onChange = this.onChange.bind(this);
        this.onStorage = this.onStorage.bind(this);

        // tmg-rating-save.js (deferred, loaded in theme.liquid) owns the storage; wait for it.
        const start = () => this.load();
        if (window.tmgSavedProducts) start();
        else window.addEventListener('DOMContentLoaded', start, { once: true });
      }

      disconnectedCallback() {
        document.removeEventListener(window.tmgSavedProducts?.event, this.onChange);
        window.removeEventListener('storage', this.onStorage);
      }

      get store() {
        return window.tmgSavedProducts;
      }

      async load() {
        document.addEventListener(this.store.event, this.onChange);
        window.addEventListener('storage', this.onStorage);

        const saved = this.store.read();
        // Newest saves first.
        const cards = await Promise.all(saved.slice().reverse().map((item) => this.fetchCard(item)));
        cards.forEach((card, index) => {
          const item = saved[saved.length - 1 - index];
          if (card === null) {
            // Product no longer exists (or was saved before handles were stored): forget it.
            this.store.remove(item.id);
            return;
          }
          this.grid.appendChild(card);
        });
        this.loading.hidden = true;
        this.render();
      }

      async fetchCard(item) {
        if (!item.handle) return null;
        try {
          const url = `${this.dataset.productsRoot}products/${encodeURIComponent(item.handle)}?section_id=${this.cardSection}`;
          const response = await fetch(url);
          if (!response.ok) return null;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const card = html.querySelector('.tmg-card');
          if (!card) return null;
          const li = document.createElement('li');
          li.className = 'tmg-wishlist__item';
          li.dataset.productId = item.id;
          li.appendChild(card);
          return li;
        } catch (error) {
          // Network failure: keep the item saved, just don't show it this time.
          return undefined;
        }
      }

      onChange(event) {
        if (event.detail?.saved !== false) return;
        this.grid.querySelector(`[data-product-id="${event.detail.productId}"]`)?.remove();
        this.render();
      }

      onStorage(event) {
        if (event.key !== this.store.storageKey) return;
        // Saved list changed in another tab: rebuild from scratch.
        this.grid.replaceChildren();
        this.loading.hidden = false;
        this.load();
      }

      render() {
        const total = this.grid.children.length;
        this.grid.hidden = total === 0;
        this.empty.hidden = total > 0;
        this.count.hidden = total === 0;
        this.count.textContent = `${total} ${total === 1 ? 'item' : 'items'}`;
      }
    }
  );
}
